module.exports = __webpack_public_path__ + "img/no-results.e3279b26.svg";